export default {
  TRANSPORT_TYPE_SVP_ID: 'bcd415ea-f92f-d36f-d980-33e6055ec51e',
};
